package ch.wsl.typings.jspreadsheetCe.mod

import org.scalablytyped.runtime.StObject
import scala.scalajs.js
import scala.scalajs.js.`|`
import scala.scalajs.js.annotation.{JSGlobalScope, JSGlobal, JSImport, JSName, JSBracketAccess}

/* import warning: transforms.RemoveMultipleInheritance#findNewParents newComments Dropped parents 
- `ch.wsl.typings`.jspreadsheetCe.mod.Column because Already inherited */ @js.native
trait DropdownColumn
  extends StObject
     with BaseColumn {
  
  var autocomplete: js.UndefOr[Boolean] = js.native
  
  /**
    * Allow selection of more than one item.
    * @default false
    */
  var multiple: js.UndefOr[Boolean] = js.native
  
  /** Options available in the dropdown. */
  var source: js.UndefOr[js.Array[DropdownSourceItem]] = js.native
  
  /** Url to fetch options from an external source. */
  var url: js.UndefOr[String] = js.native
}
object DropdownColumn {
  
  @scala.inline
  def apply(): DropdownColumn = {
    val __obj = js.Dynamic.literal()
    __obj.asInstanceOf[DropdownColumn]
  }
  
  @scala.inline
  implicit class MutableBuilder[Self <: DropdownColumn] (val x: Self) extends AnyVal {
    
    @scala.inline
    def setAutocomplete(value: Boolean): Self = StObject.set(x, "autocomplete", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setAutocompleteUndefined: Self = StObject.set(x, "autocomplete", js.undefined)
    
    @scala.inline
    def setMultiple(value: Boolean): Self = StObject.set(x, "multiple", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setMultipleUndefined: Self = StObject.set(x, "multiple", js.undefined)
    
    @scala.inline
    def setSource(value: js.Array[DropdownSourceItem]): Self = StObject.set(x, "source", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setSourceUndefined: Self = StObject.set(x, "source", js.undefined)
    
    @scala.inline
    def setSourceVarargs(value: DropdownSourceItem*): Self = StObject.set(x, "source", js.Array(value :_*))
    
    @scala.inline
    def setUrl(value: String): Self = StObject.set(x, "url", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setUrlUndefined: Self = StObject.set(x, "url", js.undefined)
  }
}
